import React, {useState} from 'react';
import './industrySection.scss'
import Button from '@components/common/button/button';
import TextField from "@components/common/textField/textField";
import Collapsible from '@components/common/collapsible/collapsible'
import ArrowRight from "@images/icons/arrow-right.svg";
import {graphql, navigate, useStaticQuery} from "gatsby";
import {GatsbyImage} from "gatsby-plugin-image";
import ButtonGatsbyImage from "@components/common/buttonGatsbyImage/buttonGatsbyImage";

function IndustrySection() {

  const data = useStaticQuery(graphql`
    query {
      allIndustriesDataJson {
        edges {
          node {
            id
            industryUrl
            name
            src {
             childImageSharp {
                gatsbyImageData (
                  quality: 100,
                  outputPixelDensities: 2, 
                  placeholder: NONE,
                  backgroundColor: "#27304D"
                  height: 32
                  width: 32
                  )
                }
              }
            images {
              className
              description
              imgAlt
              imageUrl {
              childImageSharp {
                gatsbyImageData (
                  quality: 100,
                  outputPixelDensities: 2, 
                  placeholder: NONE,
                  backgroundColor: "#27304D"
                  pngOptions: {quality: 100}
                  )
                fixed(width: 375) {
                  base64
                  tracedSVG
                  aspectRatio
                  srcWebp
                  srcSetWebp
                  originalName
                }
                }
              }
              pageUrl
              title
            }
          }
        }
      }
    }
  `)

  const industryData = Object.values(data.allIndustriesDataJson.edges);

  const [activeItem, setActiveItem] = useState('Coaching & Consulting');

  const industryJsonData = industryData.filter(industryData => industryData.node.name === activeItem)

  const exploreIndustries = () => {
    navigate(industryJsonData[0].node.industryUrl);
  }

  return (
    <div className='homepage-is-wrapper'>
      <div className='homepage-is-wrapper__industry-section'>
        <div className='homepage-is-wrapper__industry-section__headline'>
            <h2>All service-based businesses can benefit from Trafft</h2>
          <div className='homepage-is-wrapper__industry-section__headline__subtitle'>
            Trafft is simple yet powerful appointment scheduling software flexible enough to adapt to different industries and business types
          </div>
        </div>
          <div className='homepage-is-wrapper__industry-section__image-wrapper'>
            <div className='homepage-is-wrapper__industry-section__image-wrapper__button-wrapper'>
              {industryData.map((industry) => (
                <ButtonGatsbyImage
                  key={industry.node.name}
                  type={activeItem === industry.node.name ? 'rounded active' : 'rounded'}
                  label={industry.node.name}
                  start={industry.node.src.childImageSharp.gatsbyImageData}
                  onClick={() => setActiveItem(industry.node.name)}
                />
              ))}
            </div>
            <div className='homepage-is-wrapper__industry-section__image-wrapper__rows'>
              {industryJsonData[0].node.images.map((image, index) =>
                <a
                  className={'homepage-is-wrapper__industry-section__image-wrapper__rows__card ' + image.className}
                  style={{textDecoration: 'none'}}
                  href={image.pageUrl}
                  key={index}
                >
                  <div id='img-holder' className='homepage-is-wrapper__industry-section__image-wrapper__rows__card__img-gradient'>
                    <GatsbyImage alt={image.imgAlt} image={image.imageUrl.childImageSharp.gatsbyImageData} />
                  </div>

                  <div className='homepage-is-wrapper__industry-section__image-wrapper__rows__card__inner-text'>
                    <TextField
                      type='default'
                      title={image.title}
                      description={image.description}
                    >
                    </TextField>
                  </div>
                </a>
              )}

              <div className='homepage-is-wrapper__industry-section__image-wrapper__rows__explore'>
                <Button
                  key={industryJsonData[0].node.name}
                  type={activeItem === industryJsonData[0].node.name ? 'rounded active' : 'rounded'}
                  label={'Explore ' + industryJsonData[0].node.name}
                  end={ArrowRight}
                  onClick={() => exploreIndustries()}
                >
                </Button>
              </div>
            </div>
          </div>
          <div className='homepage-is-wrapper__industry-section__collapsible-wrapper'>
            {industryData.map((industry, index) => (
              <Collapsible
                key={index}
                label={industry.node.name}
                icon={industry.node.src.childImageSharp.gatsbyImageData}
              />
            ))}
          </div>
      </div>
    </div>
  )
}

export default IndustrySection